/* HOC which wrap app with global contexts. */
import React, { ComponentType } from 'react';

import { MatomoProvider } from 'contexts/MatomoContext';
import { AuthProvider } from 'contexts/AuthContext';
import { BusyProgressProvider } from 'contexts/BusyProgressContext';
import { CategoriesProvider } from 'contexts/CategoriesContext';
import { FontSettingsProvider } from 'contexts/FontSettingsContext';
import { ServerErrorProvider } from 'contexts/ServerErrorContext';
import { CustomThemeProvider } from 'contexts/ThemeContext';
import { UploadStatusProvider } from 'contexts/UploadStatusContext';
import { EcommercePlatformsProvider } from 'contexts/EcommercePlatformsContext';
import { PlanogramCloningProvider } from 'contexts/PlanogramCloningContext/PlanogramCloningContext';

export const withGlobalContextsProviders =
  <T extends Object>(AppComponent: ComponentType<T>) =>
  (props: T): JSX.Element =>
    (
      <ServerErrorProvider>
        <MatomoProvider>
          <AuthProvider>
            <CustomThemeProvider>
              <BusyProgressProvider>
                <UploadStatusProvider>
                  <FontSettingsProvider>
                    <CategoriesProvider>
                      <PlanogramCloningProvider>
                        <EcommercePlatformsProvider>
                          <AppComponent {...props} />
                        </EcommercePlatformsProvider>
                      </PlanogramCloningProvider>
                    </CategoriesProvider>
                  </FontSettingsProvider>
                </UploadStatusProvider>
              </BusyProgressProvider>
            </CustomThemeProvider>
          </AuthProvider>
        </MatomoProvider>
      </ServerErrorProvider>
    );
